// extracted by mini-css-extract-plugin
module.exports = {"content":"App_content__2oTig"};